import { approveRequest, RequestResponse } from "@api";
import { Box, Button, Grid } from "@material-ui/core";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { Modal } from "../../../screens/dashboard";
import {
  CLEAR_FILTERS_DATA,
  UPDATE_CUSTOM_FILTER,
  UPDATE_FILTERS_DATA,
  REMOVE_ROWS,
  UNSELECT_ALL,
} from "../state";
import { TableContext } from "../table";
import { RowWrapper } from "../types";
import { Filters, filterTable, Search } from "./search-filters";
import { ApprovalFilters } from "./search-filters/approvalFilters";
import { Form } from "@components/index";

const onApproveRequest = async (ids: number[], comments: string) => {
  return await approveRequest(ids, comments);
};

const customFilter = (
  rowsWrappers: RowWrapper<RequestResponse>[],
  filterData: Filters
): RowWrapper<RequestResponse>[] => {
  return rowsWrappers.filter((wrapper) => {
    return filterTable(wrapper.row.data, filterData);
  });
};

export const ApproveToolbar: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [openApprove, setOpenApprove] = useState<boolean>(false);
  const { state, dispatch } = useContext(TableContext);
  const { rows, selectedRows } = state;
  const [searchValue, setSearchValue] = useState<string>("");

  const form = Form.useManager<Filters>({
    environment: "",
    dateType: "",
    status: "",
    systemName: "",
    dateFrom: null,
    dateTo: null,
    typeOfAction: "",
  });

  useEffect(() => {
    dispatch({ type: UPDATE_CUSTOM_FILTER, customFilter });
  }, [dispatch]);

  const onSearchUpdate = useCallback(
    (term: string) => {
      setSearchValue(term);
      dispatch({
        type: UPDATE_FILTERS_DATA,
        filtersData: { searchTerm: term },
      });
    },
    [dispatch]
  );

  const onSubmitApproval = useCallback(
    async (comments: string) => {
      const ids = [];
      for (const i in selectedRows) {
        ids.push(selectedRows[i].row.data.id);
      }
      const success = await onApproveRequest(ids, comments);
      if (success) {
        dispatch({ type: REMOVE_ROWS, rows: selectedRows });
        dispatch({ type: UNSELECT_ALL });
      }
      return { success };
    },
    [dispatch, selectedRows]
  );

  return (
    <Box mt={2} mb={2}>
      <Grid container direction="row" spacing={2}>
        <Grid item container xs={12} justify="flex-end">
          <Grid item xs={3}>
            <Search
              onSearchUpdate={onSearchUpdate}
              placeholder={"Search by Reference No"}
              defaultValue={searchValue}
            ></Search>
          </Grid>
        </Grid>
        <Grid item xs={8}>
          <Button
            disabled={Object.keys(selectedRows).length === 0}
            variant="contained"
            color="primary"
            onClick={() => setOpenApprove(true)}
          >
            Approve Request
          </Button>
        </Grid>
        <Grid item container xs={4} justify="flex-end">
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setOpen(true)}
          >
            Filters
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              dispatch({ type: CLEAR_FILTERS_DATA });
              form.reset();
              setSearchValue("");
            }}
            style={{ marginLeft: "40px" }}
          >
            Reset Filters
          </Button>
        </Grid>
      </Grid>
      <ApprovalFilters
        open={open}
        requests={rows}
        form={form}
        onApply={(filters: Filters) => {
          setOpen(false);
          dispatch({ type: UPDATE_FILTERS_DATA, filtersData: filters });
        }}
        onCancel={() => {
          setOpen(false);
        }}
      />
      <Modal
        closeModal={() => setOpenApprove(false)}
        title={"Approve Request"}
        isOpen={openApprove}
        buttonText="APPROVE REQUEST"
        successMessage="Successfully Approved"
        onAction={onSubmitApproval}
      ></Modal>
    </Box>
  );
};
